import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const authToken = localStorage.getItem('authToken');

  // If no auth token, redirect to login
  if (!authToken) {
    return <Navigate to="/unauthorized" replace state={{ from: window.location.pathname }} />;
  }

  // If authenticated, render the route
  return children ? children : <Outlet />;
};

export default ProtectedRoute;